<template>
    <div class="month_calendar_wrap">
      <div class="calendar_date">
        <span>{{ year }}年 {{currentIndex + 1}}月</span>
      </div>
      <v-touch @swipeleft="onSwipeLeft" @swiperight="onSwipeRight" tag="div">
        <div @touchmove="handleTouchMove" class="weekBox">
          <span
            v-for="(week, index) in 12"
            :key="index"
            @click="changeMonthFun(index)"
            :class="currentIndex === index ? 'itemSty active' : 'itemSty'"
          >
            第{{ index + 1 }}月</span
          >
        </div>
      </v-touch>
    </div>
  </template>
  <script>

  export default {
    name: "MonthCalendar",
    data() {
      return {
        months: [],
        currentYear: "",
        year: "",
        month: "",
        currentIndex: 0,
        currentMonth: [],
      };
    },
    mounted() {
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var currentMonth = currentDate.getMonth(); // 月份从0开始，所以要加
      this.currentYear = currentYear;
      this.year = currentYear;
      this.month = currentMonth + 1;
      this.currentIndex = currentMonth;
      this.currentMonth = this.getMonthStartAndEnd(this.year, this.month);
      this.$emit("groun-month-change", this.currentMonth)
    },
    methods: {
      getMonthStartAndEnd(year, month) {
        const date = new Date(year, month - 1, 1);
        const monthStart = new Date(date.getFullYear(), date.getMonth(), 1); // 月初的时间戳
  
        // 获取当月天数
        const daysInMonth = new Date(year, month, 0);
        // 月末的时间戳
        const monthEnd = new Date(
          daysInMonth.getFullYear(),
          daysInMonth.getMonth() + 1,
          0
        );
        return [monthStart, monthEnd];
      },
      changeMonthFun(index) {
        this.currentIndex = index;
        this.currentMonth = this.getMonthStartAndEnd(this.year, index + 1);
        this.$emit("groun-month-change", this.currentMonth);
      },
      //左滑 下一个
      onSwipeLeft() {
        if (this.year < this.currentYear) {
          this.year++;
        }
        this.currentMonth = this.getMonthStartAndEnd(
          this.year,
          this.currentIndex + 1
        );
      },
      //右滑 上一个
      onSwipeRight() {
        this.year--;
        this.$forceUpdate();
        this.currentMonth = this.getMonthStartAndEnd(
          this.year,
          this.currentIndex + 1
        );
      },
      handleTouchMove(event) {
        const scrollableContent = event.currentTarget;
        const isScrollable =
          scrollableContent.scrollWidth > scrollableContent.clientWidth; // 判断是否需要滚动
        if (!isScrollable) {
          event.preventDefault(); // 阻止默认行为，让外层 v-touch 触发
        }
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .month_calendar_wrap {
    padding: 12px 24px;
    .calendar_date {
        display: flex;
        justify-content: space-between;
        span:nth-child(1) {
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
        }
    }
  }
  .weekBox {
    // white-space: nowrap;
    // width: 1000px;
    // overflow-x: auto;
    .itemSty {
        display: inline-block;
        vertical-align: top;
        width: 64px;
        height: 24px;
        opacity: 1;
        text-align: center;
        line-height: 24px;

        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        color: rgba(102, 102, 102, 1);
        border-radius: 12px;
        background: rgba(243, 243, 243, 1);
        margin-right: 8px;
        margin-top: 10px;
        &.active {
            color: rgba(25, 144, 255, 1);
            background: rgba(25, 144, 255, 0.16);
        }
    }
}
  </style>
  